import { Typography } from "@/components/kit";
import Breadcrumb from "./Breadcrumb";
import { useNavigate } from "react-router-dom";
import SvgIcon from "@/components/common/SvgIcon";

function AppBar() {
  const navigate = useNavigate();
  return (
    <header className="flex flex-col sm:flex-row gap-2 h-[56px] px-6 py-3 content-between sm:items-center sm:justify-between w-full border-b border-gray-50 dark:border-gray-900">
      <Breadcrumb />
      <div
        className="bg-gray-50 rounded p-1 flex items-center gap-1 cursor-pointer"
        onClick={() => navigate("/intercom/ticket/")}
      >
        <SvgIcon iconName="helpFill" className="w-5 h-5 fill-gray-800" />
        <Typography variant="Caption1-Regular">Trio Support</Typography>
      </div>
    </header>
  );
}

export default AppBar;
